import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import AppClientHeader from "../../components/App/AppClientHeader";
import ClientsNav from "../../components/Clients/ClientsNav";
import { getZohoPagesense } from "../../utils/helpers";
import { withRouter } from "../../utils/withRouter";
import { useNavContext } from "../../Context/NavContext";
import styles from "./index.module.css";

const Layout = ({
  location,
  user,
  screen,
  isLoggedIn,
  appThemeData,
  appName,
  headerTab,
  progressPercent,
  skipLoginCheck,
  removePadding,
}) => {
  const { selectedNavItem } = useNavContext();
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    callZoho();
  }, []);

  const callZoho = async () => {
    try {
      await getZohoPagesense();
    } catch (e) {
      console.log("error -->", e.message);
    }
  };

  const pathname =
    typeof location === "string"
      ? location
      : location?.pathname ?? "";

  // Redirect logic based on user roles
  if (!isLoggedIn && !skipLoginCheck) {
    return (
      <></>
      // <Navigate
      //   to={{
      //     pathname: "/login",
      //     state: { from: location },
      //   }}
      // />
    );
  }

  if (user.client_admin === false && user.is_employee === true) {
    if (pathname === "/client/settings" || pathname === "/client/team") {
      return (
        <Navigate
          to={{
            pathname: "/client/dashboard",
            state: { from: pathname },
          }}
        />
      );
    }
  }

  if (
    user.super_admin === false &&
    user.client_admin === false &&
    user.is_employee === false &&
    user.admin === false &&
    user.type !== "DepositUser"
  ) {
    return (
      <Navigate
        to={{
          pathname: "/dashboard/accounts/invoices",
          state: { from: pathname },
        }}
      />
    );
  }

  if (user.super_admin === true) {
    return (
      <Navigate
        to={{
          pathname: "/super-admin/accounts",
          state: { from: pathname },
        }}
      />
    );
  }

  if (user.type === "DepositUser" && !pathname.startsWith("/sales_user")) {
    return (
      <Navigate
        to={{
          pathname: "/sales_user/payments",
          state: { from: pathname },
        }}
        replace
      />
    );
  }

  const isDepositUser = user.type === "DepositUser";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
      }}
    >
      <Helmet>
        <title>{appName ? `${appName} | ${selectedNavItem}` : selectedNavItem}</title>
      </Helmet>
      <ClientsNav
        path={pathname}
        user={user}
        className={`${styles.clientsNav}`}
        disableNav={
          user.openid_id != null
            ? false
            : !user.is_employee && user.client_admin
              ? false
              : true
        }
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          overflowX: "hidden",
        }}
      >
        <AppClientHeader
          user={user}
          appThemeData={appThemeData}
          appName={appName}
          logoPath={isDepositUser ? '/sales_user/payments' : '/client/accounts/'}
          hideNav={true}
          headerTab={headerTab}
        />

        <div
          // style={
          //   removePadding
          //     ? { padding: 0, backgroundColor: "#F0F4F6" }
          //     : { padding: "1rem", backgroundColor: "#F0F4F6" }
          // }
          style={{
            backgroundColor: "#F0F4F6",
          }}
        >
          {screen}
        </div>
      </div>
    </div>
  );
};

Layout.propTypes = {
  location: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  screen: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  appThemeData: PropTypes.object.isRequired,
  appName: PropTypes.string.isRequired,
  headerTab: PropTypes.string.isRequired,
  progressPercent: PropTypes.number.isRequired,
  removePadding: PropTypes.bool,
};

export default withRouter(Layout);
